export const formList = [
  'login',
  'register',
  'resetPassword',
  'contractFormApp',
  'assignments',
  'companyProfile',
  'password',
  'addEmail',
  'contractForm',
  'searchEmail',
  'workshift'
]
